import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'map-app-breadcrumb',
  templateUrl: './map-breadcrumb.component.html',
  styleUrls: ['./map-breadcrumb.component.scss']
})
export class MapBreadcrumbComponent implements OnInit {
  routeName: string;
  routeURL: string;
  isRefining: boolean = false;
  isAdditives: boolean = false;
  isPetro: boolean = false;
  hasCategories: boolean = false;
  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.routeName = params.title;
      this.getCategories(params.processMapId);

    });



  }
  getCategories(routeId) {
    switch (routeId) {
      case "1": {
        this.isRefining = true;
        this.isPetro = false;
        this.isAdditives = false;
        this.hasCategories = true;
        break;
      }
      case "2": {
        this.isRefining = false;
        this.isPetro = true;
        this.isAdditives = false;
        this.hasCategories = true;
        break;
      }
      case "3": {
        this.isRefining = false;
        this.isPetro = false;
        this.isAdditives = true;
        this.hasCategories = true;
        break;
      }
      default: {
        this.hasCategories = false;
        break;
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/breadcrumb/map-breadcrumb.component.ts